import { CurrencyPipe } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { ThemeService } from 'src/app/core/services/theme/theme.service';

@Component({
  selector: 'app-bounty-pill',
  templateUrl: './bounty-pill.component.html',
  styleUrls: ['./bounty-pill.component.scss'],
})
export class BountyPillComponent {
  @Input() amount?: number;
  @Input() disabled = false;
  @Input() layout: 'hug' | 'fill' = 'hug';
  @Input() size: 'extra-small' | 'small' | 'medium' | 'large' = 'small';
  @Input() buttonBgColor?: string;

  themeService = inject(ThemeService);
  private currencyPipe = inject(CurrencyPipe);

  // TODO: refactor this to support MCN and other currencies once operator is enabled
  get formattedAmount(): string {
    if (this.amount === undefined) return '';
    const formattedValue =
      this.amount < 1
        ? `${Math.round(this.amount * 100)}¢`
        : this.currencyPipe.transform(
            this.amount,
            'USD',
            'symbol',
            this.amount % 1 === 0 ? '1.0-0' : '1.0-2',
          );

    return formattedValue ?? '';
  }
}
